// extracted by mini-css-extract-plugin
var _1 = "oXEPFRiDAVMJvfkR2NEb";
var _2 = "NVNOtyEHQwVHyAZwKJPE";
var _3 = "XLARmjz81oUmUjgMO_kO";
var _4 = "YfWUSygT7IUJkNw3k2EP";
var _5 = "OOQ0w77e4stCfvIl64Wi";
var _6 = "NVNOtyEHQwVHyAZwKJPE";
var _7 = "XLARmjz81oUmUjgMO_kO";
var _8 = "YfWUSygT7IUJkNw3k2EP";
var _9 = "OOQ0w77e4stCfvIl64Wi";
export { _1 as "title", _2 as "work-experience", _3 as "work-experience-company", _4 as "work-experience-job-position", _5 as "work-experience-period-of-employment", _6 as "workExperience", _7 as "workExperienceCompany", _8 as "workExperienceJobPosition", _9 as "workExperiencePeriodOfEmployment" }
